import React from "react";
import History from "../../History";
import Upload from "../../Upload";
import MentiAvatar from '../../images/menti_bot.png'
import "../../styles/ChatSidebar.css";

interface EducationalContext {
    className?: string;
    subjectName?: string;
    seriesName?: string;
    chapterName?: string;
    topicName?: string | null;
}

interface Conversation {
    id: string;
    title: string;
    messages: any[];
}

interface ChatSidebarProps {
    context?: EducationalContext;
    className?: string;
    closeSidebar?: () => void;
    historyRef: any;
    startNewChat: () => void;
    fetchDocuments: () => void;
    documents: string[];
    selectedDocument: string;
    setSelectedDocument: (value: string) => void;
    removeSelectedDocument: () => void;
    onConversationSelect: (conversation: Conversation) => void;
    onConversationRemove: (id: string) => void;
}

export default function ChatSidebar({
    context,
    historyRef,
    startNewChat,
    fetchDocuments,
    documents,
    selectedDocument,
    setSelectedDocument,
    removeSelectedDocument,
    onConversationSelect,
    onConversationRemove,
}: ChatSidebarProps) {
    return (
        <aside className="chat-sidebar">

            <div className="sidebar-logo">
                <div className="sidebar-logo-icon">
                    <img src={MentiAvatar} alt="Mentiora AI" width={50} />
                </div>

                <div>
                    <h4>Mentiora</h4>
                    <small>Your AI Learning Companion</small>
                </div>
            </div>

            <button
                className="new-chat-btn"
                onClick={startNewChat}
            >
                ✨ New Chat
            </button>

            <div className="sidebar-section">

                <div className="sidebar-title">

                    Recent Chats

                </div>

                <History
                    ref={historyRef}
                    onConversationSelect={onConversationSelect}
                    onConversationRemove={onConversationRemove}
                />

            </div>

            {!context && (

                <>

                    <div className="sidebar-section">

                        <div className="sidebar-title">

                            Upload PDF

                        </div>

                        <Upload onUploaded={fetchDocuments} />

                    </div>

                    <div className="sidebar-section">

                        <div className="sidebar-title">

                            Documents

                        </div>

                        <select
                            className="sidebar-select"
                            value={selectedDocument}
                            onChange={(e) =>
                                setSelectedDocument(e.target.value)
                            }
                        >
                            <option value="">
                                All Documents
                            </option>

                            {documents.map((doc) => (

                                <option
                                    key={doc}
                                    value={doc}
                                >
                                    {doc}
                                </option>

                            ))}

                        </select>

                        <button
                            className="remove-doc-btn"
                            disabled={!selectedDocument}
                            onClick={removeSelectedDocument}
                        >
                            Remove Document
                        </button>

                    </div>

                </>

            )}

            {context && (

                <div className="sidebar-section">

                    <div className="sidebar-title">

                        Learning Context

                    </div>

                    <div className="learning-card">

                        <div>{context.className}</div>

                        <div>{context.subjectName}</div>

                        <div>{context.seriesName}</div>

                        <div>{context.chapterName}</div>

                        {context.topicName && (
                            <div>{context.topicName}</div>
                        )}

                    </div>

                </div>

            )}

        </aside>
    );
}